import { useCallback } from "react";
import { useRecoilState } from "recoil";

import { rideTabsBottomBlocksExpandedAtom } from "@ryde/shared";

export const useRideTabsBottomBlocksExpand = () => {
  const [isExpanded, setIsExpanded] = useRecoilState(
    rideTabsBottomBlocksExpandedAtom,
  );

  const toggleExpanded = useCallback((): void => {
    setIsExpanded(prev => !prev);
  }, [setIsExpanded]);

  return {
    isExpanded,
    toggleExpanded,
  };
};
